import PropTypes from 'prop-types';
import { BatchSinglePropType } from './batch-single';

export const BatchPropType = PropTypes.arrayOf(BatchSinglePropType);

/**
 * @typedef {BatchSinglePropType[]} BatchPropType
 */
